(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-3');
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-3');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-background-3');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-3');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
  constructor() { super(); }
  hide() { super.hide(); window.pauseAllMedia(); }
  show(opener) { super.show(opener); this.showActiveMedia(); }
  showActiveMedia() {
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}
customElements.define('product-modal', ProductModal);

// Robust init — Shopify aggregates {% javascript %} blocks into an external
// JS file that often loads AFTER DOMContentLoaded has already fired, in which
// case `addEventListener('DOMContentLoaded', …)` never executes. We check
// document.readyState and call the init function immediately if the DOM is
// already parsed.
window.__initSkinPharmacyPdp = function __initSkinPharmacyPdp() {
  // Init-once guard — the backup inline script may also call us.
  if (window.__skinPharmacyPdpInited) return;
  // Pull Liquid-derived values from the inline-script config (see comment
  // above the inline <script> in the section HTML for why this is needed).
  var cfg = window.__skinPharmacyPdpConfig || {};
  var section = document.getElementById(cfg.sectionElementId || '');
  if (!section) {
    // Last-ditch fallback for older/edge configs
    section = document.querySelector('[id^="MainProduct-"]');
  }
  if (!section) return;
  window.__skinPharmacyPdpInited = true;

  // Expose a minimal debug surface IMMEDIATELY so __pdpDebug is queryable
  // even if later code throws. We'll fill in the rest at the bottom.
  window.__pdpDebug = window.__pdpDebug || {};
  window.__pdpDebug.section = section;
  window.__pdpDebug.initStarted = Date.now();

  try { console.log('[SkinPharmacy PDP] init started for', section.id); } catch (e) {}

  var moneyFormat = cfg.moneyFormat || '${{amount}}';
  var otpPrice    = parseInt(section.getAttribute('data-otp-price') || '0', 10) || 0;

  // ── Underline removal via inline style ───────────────────────────────────
  function removeIconUnderlines() {
    section.querySelectorAll(
      '.product__text-icon-btn, .product__text-icon-btn span, ' +
      '.product-popup, .product__text-icon--popup, ' +
      '.product-popup modal-opener, .product__text-icon--popup modal-opener, ' +
      '.product-popup modal-opener *, .product__text-icon--popup modal-opener *'
    ).forEach(function(el) {
      // Skip anything inside a block flagged with [data-underline] — those
      // are intentionally underlined via the Customizer "Style as hyperlink"
      // tickbox and must not be reset back to "no underline".
      if (el.closest && el.closest('[data-underline]')) return;
      el.style.setProperty('text-decoration',      'none', 'important');
      el.style.setProperty('text-decoration-line', 'none', 'important');
    });
    section.querySelectorAll('.product__text-icon-link').forEach(function(el) {
      el.style.setProperty('text-decoration',       'underline', 'important');
      el.style.setProperty('text-decoration-line',  'underline', 'important');
      // Force the offset inline so it can't be reset by any other rule —
      // standard link spacing, clear of the letters but not floating.
      el.style.setProperty('text-underline-offset', '3px', 'important');
      el.style.setProperty('text-decoration-thickness', '1px', 'important');
    });
    // Apply inline underline to every span inside [data-underline] so it
    // wins against any other inline-style rule on the row. Faded + thin.
    section.querySelectorAll('[data-underline] span').forEach(function(el) {
      el.style.setProperty('text-decoration',       'underline', 'important');
      el.style.setProperty('text-decoration-line',  'underline', 'important');
      el.style.setProperty('text-decoration-color', 'rgba(var(--color-foreground), 0.35)', 'important');
      el.style.setProperty('text-decoration-thickness', '0.5px', 'important');
      el.style.setProperty('text-underline-offset', '4px',      'important');
    });
  }
  removeIconUnderlines();
  setTimeout(removeIconUnderlines, 800);
  setTimeout(removeIconUnderlines, 2000);

  var allocMap = {};
  try {
    var allocs = cfg.sellingPlanAllocations || [];
    if (Array.isArray(allocs)) {
      allocs.forEach(function(a) {
        var id = a.selling_plan_id || (a.selling_plan && a.selling_plan.id);
        if (id !== undefined && id !== null) allocMap[String(id)] = a.price;
      });
    }
  } catch(e) {}

  var spAllocMap = {};
  var variantOtpPriceMap = {};

  // ── Populate variantOtpPriceMap IMMEDIATELY from server-rendered JSON ─────
  // The variant_picker block emits <script data-product-variants-json> with
  // all variants. Reading this synchronously means the map is ready before
  // the user can even click — no dependency on a network fetch finishing.
  (function seedVariantMapFromInlineJson() {
    try {
      section.querySelectorAll('[data-product-variants-json]').forEach(function(scriptEl) {
        var variants = JSON.parse(scriptEl.textContent || '[]');
        if (!Array.isArray(variants)) return;
        variants.forEach(function(v) {
          if (v && v.id !== undefined && v.price !== undefined) {
            variantOtpPriceMap[String(v.id)] = v.price;
          }
        });
      });
    } catch (e) {}
  })();

  // Still fetch the JSON endpoint to pick up selling-plan allocations
  // (those aren't in the inline JSON in some theme versions).
  fetch('/products/' + (cfg.productHandle || '') + '.js')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data && data.variants) {
        data.variants.forEach(function(v) {
          if (variantOtpPriceMap[String(v.id)] === undefined) {
            variantOtpPriceMap[String(v.id)] = v.price;
          }
          if (v.selling_plan_allocations && v.selling_plan_allocations.length) {
            spAllocMap[String(v.id)] = {};
            v.selling_plan_allocations.forEach(function(a) {
              spAllocMap[String(v.id)][String(a.selling_plan_id)] = a.price;
            });
          }
        });
      }
      syncAllPrices();
    })
    .catch(function() {});

  var lastAtcPrice  = '';
  var themePriceId  = cfg.priceSelector || '#price-' + (cfg.sectionId || '');

  // ── Robust subscription detection ─────────────────────────────────────────
  // Checks (any one returns true → subscription is active):
  //  1. The form's `selling_plan` hidden input has a non-empty / non-zero value
  //  2. The active SealSubs card has a meaningful data-selling-plan-group-id
  //  3. The active card contains the subscription group options block
  //  4. The active card has a subs interval <select>
  //  5. The active card's name text contains the word "subscription"
  function detectSubscription() {
    var sp = section.querySelector('[name="selling_plan"]');
    if (sp && sp.value && sp.value !== '' && sp.value !== '0') return true;
    var activeCard = section.querySelector('.sls-option-container.sls-active');
    if (activeCard) {
      var groupId = activeCard.getAttribute('data-selling-plan-group-id');
      if (groupId && groupId !== '' && groupId !== '0') return true;
      var planId  = activeCard.getAttribute('data-selling-plan-id');
      if (planId && planId !== '' && planId !== '0') return true;
      if (activeCard.querySelector('.sls-selling-plan-group-options')) return true;
      if (activeCard.querySelector('.sls-select, select[name="subs_interval"]')) return true;
      var nameEl = activeCard.querySelector('.sls-selling-plan-group-name');
      if (nameEl && /subscription/i.test(nameEl.textContent || '')) return true;
    }
    return false;
  }

  // ── Force the ATC button into our "Label | Price" shape ─────────────────
  // The theme's variant-radios JS does `addButtonText.textContent = "…"` on
  // variant change, which deletes our three inner spans. forceAtcButton()
  // is the single source of truth — it always produces correct markup and
  // is idempotent (no-ops when nothing needs to change). Called from:
  //   - a 100ms setInterval (catches anything we miss)
  //   - a dedicated MutationObserver on each .btn__text
  //   - explicit variant-change handlers (change + click)
  var _rebuildingAtc = false;
  // Fallback formatter for when Shopify.formatMoney isn't available
  function basicMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    return '£' + (cents / 100).toFixed(2);
  }
  function formatMoneySafe(cents) {
    try { return Shopify.formatMoney(cents, moneyFormat); } catch (e) {}
    return basicMoney(cents);
  }
  // Resolve the active variant id from (in order): URL ?variant=, [name="id"]
  function resolveVariantId() {
    try {
      var urlV = new URL(window.location.href).searchParams.get('variant');
      if (urlV && variantOtpPriceMap[urlV] !== undefined) return urlV;
    } catch (e) {}
    var idInput = section.querySelector('[name="id"]');
    var v = idInput ? String(idInput.value) : null;
    if (v) return v;
    return null;
  }

  function computeAtcPrice() {
    var variantId = resolveVariantId();
    var isSub = detectSubscription();

    // SUBSCRIPTION branch — read from SealSubs allocation map or active card
    if (isSub) {
      // 1a. spAllocMap (loaded from /products/X.js fetch)
      if (variantId && spAllocMap[variantId]) {
        // Try active plan id first
        var planId = null;
        var sp = section.querySelector('[name="selling_plan"]');
        if (sp && sp.value) planId = String(sp.value);
        if (!planId) {
          var activeCardSub = section.querySelector('.sls-option-container.sls-active');
          if (activeCardSub) {
            var slsSel = activeCardSub.querySelector('.sls-select, select[name="subs_interval"]');
            if (slsSel && slsSel.value) planId = String(slsSel.value);
          }
        }
        if (planId && spAllocMap[variantId][planId] !== undefined) {
          var p1 = formatMoneySafe(spAllocMap[variantId][planId]);
          if (p1) return p1;
        }
        // Fallback to the first plan available for this variant
        var firstPlan = Object.keys(spAllocMap[variantId])[0];
        if (firstPlan && spAllocMap[variantId][firstPlan] !== undefined) {
          var p2 = formatMoneySafe(spAllocMap[variantId][firstPlan]);
          if (p2) return p2;
        }
      }
      // 1b. Read displayed subscription price from the active SealSubs card
      var activeCard = section.querySelector('.sls-option-container.sls-active');
      if (activeCard) {
        var moneyEl = activeCard.querySelector('.sls-total-price .money')              ||
                      activeCard.querySelector('.sls-price .money')                    ||
                      activeCard.querySelector('.sls-selling-plan-group-price .money') ||
                      activeCard.querySelector('.sls-discount-price .money');
        if (moneyEl) {
          var mt = moneyEl.textContent.trim();
          if (mt) return mt;
        }
      }
      // 1c. Last resort for subscription — theme price element (SealSubs sometimes updates it)
      var tpeSub = section.querySelector(themePriceId);
      if (tpeSub) {
        var sealMoney = tpeSub.querySelector('.money.seal-money') ||
                        tpeSub.querySelector('.money.ht-money')   ||
                        tpeSub.querySelector('.money');
        if (sealMoney) {
          var sm = sealMoney.textContent.trim();
          if (sm) return sm;
        }
      }
      // 1d. Fallback to OTP price (we'd rather show this than empty)
      if (variantId && variantOtpPriceMap[variantId] !== undefined) {
        var pFallback = formatMoneySafe(variantOtpPriceMap[variantId]);
        if (pFallback) return pFallback;
      }
    }

    // OTP branch
    // 2a. Live variant OTP price from variantOtpPriceMap
    if (variantId && variantOtpPriceMap[variantId] !== undefined) {
      var p = formatMoneySafe(variantOtpPriceMap[variantId]);
      if (p) return p;
    }
    // 2b. Theme price element
    var tpe = section.querySelector(themePriceId);
    if (tpe) {
      var piEl = tpe.querySelector('.price-item--sale, .price-item--regular, .price-item');
      if (piEl) {
        var t = piEl.textContent.trim();
        if (t) return t;
      }
    }
    // 2c. Server-rendered initial OTP price
    return formatMoneySafe(otpPrice);
  }

  function forceAtcButton() {
    if (_rebuildingAtc) return;
    section.querySelectorAll('.product-form__submit').forEach(function(btn) {
      // Skip any button explicitly marked as "no price" — currently only the
      // Login/Register CTA on customer-price (PH Formula) products. The
      // customer-restricted variant of the same CTA does NOT carry this
      // class, so its price still updates normally.
      if (btn.classList.contains('button--no-price')) return;
      var btnText = btn.querySelector('.btn__text');
      if (!btnText) {
        // .btn__text was removed entirely — rebuild it
        var spinner = btn.querySelector('.loading-overlay__spinner');
        _rebuildingAtc = true;
        btn.innerHTML = '<span class="btn__text"></span>' + (spinner ? spinner.outerHTML : '');
        _rebuildingAtc = false;
        btnText = btn.querySelector('.btn__text');
        if (!btnText) return;
      }

      // Decide the desired label
      var rawText = (btnText.textContent || '').trim();
      var cleanedText = rawText.replace(/\s*\|\s*[£$€][\d.,]+\s*$/i, '').trim();
      var labelText;
      if (cleanedText && !/^[£$€\d.,\s|]+$/.test(cleanedText)) {
        labelText = cleanedText;
      } else {
        labelText = btn.disabled ? 'Sold Out' : 'Add to Cart';
      }

      var priceStr = computeAtcPrice() || '';

      // Idempotency check — if structure + values already correct, skip
      var curLabel = btnText.querySelector('.product-form__submit-label');
      var curPrice = btnText.querySelector('[data-atc-price]');
      if (curLabel && curPrice &&
          curLabel.textContent.trim() === labelText &&
          curPrice.textContent.trim() === priceStr) {
        return;
      }

      _rebuildingAtc = true;
      btnText.innerHTML =
        '<span class="product-form__submit-label">' + labelText + '</span>' +
        '<span class="product-form__submit-divider">|</span>' +
        '<span class="product-form__submit-price" data-atc-price>' + priceStr + '</span>';
      _rebuildingAtc = false;
    });
  }

  // Back-compat alias — older code paths still call ensureAtcStructure()
  function ensureAtcStructure() { forceAtcButton(); }

  // ── MutationObserver on each .btn__text for instant fix ─────────────────
  // Synchronous: when the theme wipes our spans, we restore them in the
  // same paint cycle so the user never sees the empty state.
  function attachAtcObservers() {
    section.querySelectorAll('.product-form__submit').forEach(function(btn) {
      if (btn._atcObserved) return;
      // Don't watch any "no price" CTA — we never want to mutate it to re-add
      // a price. customer-restricted buttons still get observed normally.
      if (btn.classList.contains('button--no-price')) return;
      btn._atcObserved = true;
      var obs = new MutationObserver(function() {
        if (_rebuildingAtc) return;
        // Schedule on next microtask so the theme's mutation batch finishes
        // before we restore — prevents fighting the theme mid-update.
        Promise.resolve().then(forceAtcButton);
      });
      obs.observe(btn, { childList: true, subtree: true, characterData: true });
    });
  }
  attachAtcObservers();
  setInterval(attachAtcObservers, 1000);

  // ── Aggressive 100ms watchdog ───────────────────────────────────────────
  // Even if every above mechanism somehow misses, this catches the bad state
  // within 100ms. Cheap because forceAtcButton is fully idempotent.
  // try/catch wrapper so a single bad cycle never breaks the interval.
  setInterval(function () {
    try { forceAtcButton(); } catch (e) {
      try { console.warn('[SkinPharmacy PDP] forceAtcButton error', e); } catch (_) {}
    }
  }, 100);

  // ── React to URL changes — the theme variant-radios JS does
  // history.replaceState(?variant=NEW_ID) on every variant switch. We patch
  // replaceState/pushState so we ALWAYS get notified, even when no native
  // 'change' event fires.
  (function watchVariantUrl() {
    var lastVariant = null;
    try {
      lastVariant = new URL(window.location.href).searchParams.get('variant');
    } catch (e) {}

    function checkUrlVariant() {
      var v = null;
      try { v = new URL(window.location.href).searchParams.get('variant'); } catch (e) {}
      if (v && v !== lastVariant) {
        lastVariant = v;
        forceAtcButton();
        setTimeout(forceAtcButton, 50);
        setTimeout(forceAtcButton, 200);
        setTimeout(forceAtcButton, 500);
        setTimeout(syncAllPrices, 60);
        setTimeout(syncAllPrices, 250);
      }
    }

    window.addEventListener('popstate', checkUrlVariant);

    // Patch history methods so theme's history.replaceState triggers us
    ['pushState', 'replaceState'].forEach(function(method) {
      var orig = history[method];
      if (typeof orig !== 'function') return;
      history[method] = function() {
        var ret = orig.apply(this, arguments);
        try { checkUrlVariant(); } catch (e) {}
        return ret;
      };
    });

    // Belt-and-braces polling — covers themes that bypass history API
    setInterval(checkUrlVariant, 200);
  })();

  // ── Debug helper: expose internals on window.__pdpDebug ───────────────
  // Open DevTools console and run:
  //   __pdpDebug.priceMap()      → see variantOtpPriceMap (all variant prices)
  //   __pdpDebug.currentVariant()→ see the live [name="id"] value
  //   __pdpDebug.priceNow()      → see what computeAtcPrice would return
  //   __pdpDebug.forceAtc()      → manually run forceAtcButton()
  //   __pdpDebug.button()        → inspect the live ATC button element
  //   __pdpDebug.sync()          → manually run syncAllPrices()
  //   __pdpDebug.isSub()         → see what detectSubscription returns
  try {
    window.__pdpDebug = {
      section: section,
      priceMap: function () { return variantOtpPriceMap; },
      spAllocMap: function () { return spAllocMap; },
      currentVariant: function () {
        var i = section.querySelector('[name="id"]');
        return i ? i.value : null;
      },
      urlVariant: function () {
        try { return new URL(window.location.href).searchParams.get('variant'); } catch (e) { return null; }
      },
      resolveVariantId: function () { return resolveVariantId(); },
      priceNow: function () { return computeAtcPrice(); },
      forceAtc: function () { return forceAtcButton(); },
      button: function () { return section.querySelector('.product-form__submit'); },
      sync:   function () { return syncAllPrices(); },
      isSub:  function () { return detectSubscription(); }
    };
  } catch (e) {}

  // ── SAVE X% yellow pill on the subscription card ───────────────────────
  // Calculates savings from (variantOtpPrice - subscriptionPrice) / otp * 100
  // and injects a .sk-save-badge next to the "REPEAT PURCHASE" label.
  // Inserted inside .sls-selling-plan-group-first-line, between the name and
  // the price, so it sits inline on the same row.
  function updateSavingsBadge() {
    // Force-hide any SealSubs native badges via inline !important style
    // (their stylesheet sometimes uses inline !important that beats ours).
    section.querySelectorAll('.sls-savings-badge').forEach(function (b) {
      b.style.setProperty('display', 'none', 'important');
    });

    section.querySelectorAll('.sls-option-container').forEach(function(card) {
      // Multi-signal subscription detection — covers every SealSubs DOM
      // variant we've seen on this theme. ANY of these = subscription card.
      var subRadio = card.querySelector('input[data-type="subscription"]');
      var ariaLabel = card.getAttribute('aria-label') ||
                      (card.querySelector('[aria-label]') && card.querySelector('[aria-label]').getAttribute('aria-label')) || '';
      var isSubscription =
        !!subRadio ||
        !!card.querySelector('.sls-selling-plan-group-options') ||
        !!card.querySelector('.sls-select, select[name="subs_interval"]') ||
        !!card.querySelector('input[data-selling-plan-group]') ||
        !!card.querySelector('[data-selling-plan-id]') ||
        /subscri|replenish|repeat/i.test(ariaLabel);

      // ALWAYS remove any existing .sk-save-badge anywhere in this card.
      card.querySelectorAll('.sk-save-badge').forEach(function (b) { b.remove(); });

      if (!isSubscription) return;

      // Find the visible name element. Try several known class names
      // because SealSubs structure varies between widget versions.
      var nameEl = card.querySelector('.sls-selling-plan-group-name')
                || card.querySelector('.sls-name')
                || card.querySelector('label.sls-label')
                || card.querySelector('.sls-label-container .sls-selling-plan-group-name')
                || card.querySelector('.sls-label-container label')
                || card.querySelector('.sls-label-container > span:first-child');

      // Last-ditch: find the deepest element inside .sls-label-container that
      // has the SealSubs subscription aria-label text rendered (visually shows
      // as "REPEAT PURCHASE" via our ::before, but the underlying text node
      // may match patterns like "Auto-Replenish" or "Subscription").
      if (!nameEl) {
        var labelContainer = card.querySelector('.sls-label-container');
        if (labelContainer) {
          // Pick the first non-empty text-bearing child
          var children = labelContainer.children;
          for (var i = 0; i < children.length; i++) {
            var c = children[i];
            if (c.children.length === 0 || c.matches('label, span, p, div')) {
              nameEl = c;
              break;
            }
          }
        }
      }

      if (!nameEl || !nameEl.parentNode) {
        try { console.warn('[SkinPharmacy PDP] No name element found in subscription card', card); } catch (e) {}
        return;
      }

      // Get OTP (full) price for the current variant
      var idInput = section.querySelector('[name="id"]');
      var variantId = idInput ? String(idInput.value) : null;
      var otpVariantPrice = (variantId && variantOtpPriceMap[variantId] !== undefined)
        ? variantOtpPriceMap[variantId]
        : otpPrice;

      // Determine the subscription price for this card (prefer alloc map).
      var subPriceValue = null;
      if (variantId && spAllocMap[variantId]) {
        var firstPlanId = Object.keys(spAllocMap[variantId])[0];
        if (firstPlanId !== undefined) {
          subPriceValue = spAllocMap[variantId][firstPlanId];
        }
      }
      if (subPriceValue === null) {
        var subPriceEl = card.querySelector('.sls-total-price .money')        ||
                         card.querySelector('.sls-price .money')              ||
                         card.querySelector('.sls-discount-price .money')    ||
                         card.querySelector('.sls-selling-plan-group-price .money');
        if (!subPriceEl) return;
        var subText  = (subPriceEl.textContent || '').trim();
        var subMatch = subText.match(/[\d.,]+/);
        if (!subMatch) return;
        subPriceValue = Math.round(parseFloat(subMatch[0].replace(/,/g, '')) * 100);
      }

      if (!otpVariantPrice || subPriceValue >= otpVariantPrice) return;
      var savingsPct = Math.round((otpVariantPrice - subPriceValue) / otpVariantPrice * 100);
      if (savingsPct <= 0) return;

      // Build fresh badge and insert it immediately AFTER the name element,
      // wherever the name lives. DOM order becomes "name → badge → next-sibling".
      var badge = document.createElement('span');
      badge.className = 'sk-save-badge';
      badge.textContent = 'SAVE ' + savingsPct + '%';
      nameEl.insertAdjacentElement('afterend', badge);
    });
  }

  // ── Match variant labels & SealSubs card corners to the ATC button ─────────
  // Reads the ATC button's computed border-radius and applies it to the
  // variant option labels + SealSubs containers so all card corners agree
  // with whatever the theme's button radius is.
  function matchAtcRadius() {
    var atcEl = section.querySelector('.product-form__submit');
    if (!atcEl) return;
    var atcRadius = getComputedStyle(atcEl).borderRadius;
    if (!atcRadius || atcRadius === '0px' || atcRadius === 'auto') return;
    section.querySelectorAll(
      '.product-parameters .product-form__controls-group label, ' +
      '.product-parameters .product-form__input label, ' +
      '.product-parameters input[type="radio"] + label, ' +
      '.sls-option-container'
    ).forEach(function(el) {
      el.style.setProperty('border-radius', atcRadius, 'important');
    });
  }

  // ── Apply subscription UI state (class + inline !important style) ─────────
  // Belt-and-braces: a class on the section AND an inline !important style on
  // .product__payment-badges. Either alone has failure modes — together they
  // are bulletproof against theme re-renders and mutation-cycle resets.
  function applySubscriptionUI(isSub) {
    if (section.classList.contains('is-subscription-active') !== isSub) {
      section.classList.toggle('is-subscription-active', isSub);
    }
    var paymentBadges = section.querySelector('.product__payment-badges');
    if (paymentBadges) {
      if (isSub) {
        paymentBadges.style.setProperty('display', 'none', 'important');
      } else {
        paymentBadges.style.removeProperty('display');
      }
    }
  }

  function syncAllPrices() {
    // Rebuild ATC button structure first — if the theme JS replaced
    // .btn__text on a variant change, our [data-atc-price] target is gone
    // and nothing else in this function can update it. ensureAtcStructure
    // restores Label | Price markup; downstream code then fills the price.
    ensureAtcStructure();

    var themePriceEl  = section.querySelector(themePriceId);
    var preGalleryEl  = section.querySelector('.product__pre-gallery-price');
    var activeCard    = section.querySelector('.sls-option-container.sls-active');

    var priceText      = '';
    var isSubscription = detectSubscription();

    if (isSubscription) {
      if (themePriceEl) {
        var sealMoneyEl = themePriceEl.querySelector('.money.seal-money') ||
                          themePriceEl.querySelector('.money.ht-money')   ||
                          themePriceEl.querySelector('.money');
        if (sealMoneyEl) priceText = sealMoneyEl.textContent.trim();
      }
      if (!priceText && activeCard) {
        var slsMoney = activeCard.querySelector('.sls-total-price .money')              ||
                       activeCard.querySelector('.sls-price .money')                    ||
                       activeCard.querySelector('.sls-selling-plan-group-price .money') ||
                       activeCard.querySelector('.sls-discount-price .money');
        if (slsMoney) priceText = slsMoney.textContent.trim();
      }
      if (!priceText) {
        var variantInput = section.querySelector('[name="id"]');
        var variantId    = variantInput ? String(variantInput.value) : null;
        var planId       = null;
        if (activeCard) {
          var slsSelect = activeCard.querySelector('.sls-select, select[name="subs_interval"]');
          if (slsSelect && slsSelect.value) planId = String(slsSelect.value);
        }
        if (!planId) {
          var sellingPlanInput = section.querySelector('[name="selling_plan"]');
          if (sellingPlanInput && sellingPlanInput.value && sellingPlanInput.value !== '') {
            planId = String(sellingPlanInput.value);
          }
        }
        if (variantId && planId && spAllocMap[variantId] && spAllocMap[variantId][planId] !== undefined) {
          try { priceText = Shopify.formatMoney(spAllocMap[variantId][planId], moneyFormat); } catch(e) {}
        }
        if (!priceText && variantId && spAllocMap[variantId]) {
          var firstKey = Object.keys(spAllocMap[variantId])[0];
          if (firstKey !== undefined) {
            try { priceText = Shopify.formatMoney(spAllocMap[variantId][firstKey], moneyFormat); } catch(e) {}
          }
        }
      }
      if (!priceText && themePriceEl) {
        var piEl = themePriceEl.querySelector('.price-item--sale, .price-item--regular, .price-item');
        if (piEl) priceText = piEl.textContent.trim();
      }
      if (!priceText) {
        try { priceText = Shopify.formatMoney(Math.round(otpPrice * 0.9), moneyFormat); } catch(e) {}
      }
    } else {
      // OTP: prefer the live variant's price from variantOtpPriceMap.
      // This avoids a race where the theme's price element hasn't repainted yet
      // immediately after a variant change — the map is always source-of-truth.
      var variantInputOtp = section.querySelector('[name="id"]');
      var variantIdOtp    = variantInputOtp ? String(variantInputOtp.value) : null;
      if (variantIdOtp && variantOtpPriceMap[variantIdOtp] !== undefined) {
        try { priceText = Shopify.formatMoney(variantOtpPriceMap[variantIdOtp], moneyFormat); } catch(e) {}
      }
      if (!priceText && themePriceEl) {
        var priceItemEl = themePriceEl.querySelector('.price-item--sale, .price-item--regular, .price-item');
        if (priceItemEl) priceText = priceItemEl.textContent.trim();
      }
      if (!priceText && activeCard) {
        var slsMoney = activeCard.querySelector('.sls-price .money')       ||
                       activeCard.querySelector('.sls-total-price .money') ||
                       activeCard.querySelector('.sls-selling-plan-group-price .money');
        if (slsMoney) priceText = slsMoney.textContent.trim();
      }
    }

    if (!priceText && themePriceEl) {
      var piEl = themePriceEl.querySelector('.price-item--sale, .price-item--regular, .price-item');
      if (piEl) priceText = piEl.textContent.trim();
    }
    if (!priceText) {
      try { priceText = Shopify.formatMoney(otpPrice, moneyFormat); } catch(e) {}
    }

    // ─── 5. Update ATC button price ────────────────────────────────────────
    if (priceText) {
      section.querySelectorAll('[data-atc-price]').forEach(function(el) {
        if (el.textContent.trim() !== priceText) el.textContent = priceText;
      });
      lastAtcPrice = priceText;
    }

    // ─── 5b. Dynamic loyalty points: update directly from computed price ────
    // Uses the same price already computed (OTP or subscription), so points
    // always match exactly what the ATC button shows — no DOM re-read needed.
    // Points always reflect the FULL price — the sale display must not change earning.
    var _pts_vid  = (section.querySelector('[name="id"]') || {}).value;
    var _pts_full = (_pts_vid && variantOtpPriceMap[String(_pts_vid)] !== undefined)
      ? variantOtpPriceMap[String(_pts_vid)] : otpPrice;
    if (_pts_full > 0) updateDynamicPoints(_pts_full);

    // ─── 6. Update Clearpay / Klarna installment amounts ──────────────────
    var priceNumeric = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    if (priceNumeric > 0) {
      var cpInstalment   = (priceNumeric / 4).toFixed(2);
      var klInstalment   = (Math.ceil(priceNumeric / 3 * 100) / 100).toFixed(2);
      var currencySymbol = priceText.replace(/[0-9.,\s]/g, '').trim() || '£';
      section.querySelectorAll('[data-clearpay-amount]').forEach(function(el) {
        var t = currencySymbol + cpInstalment;
        if (el.textContent.trim() !== t) el.textContent = t;
      });
      section.querySelectorAll('[data-klarna-amount]').forEach(function(el) {
        var t = currencySymbol + klInstalment;
        if (el.textContent.trim() !== t) el.textContent = t;
      });
    }

    // ─── 7. Update mobile pre-gallery price ───────────────────────────────
    if (preGalleryEl) {
      var pgItem       = preGalleryEl.querySelector('.price-item--sale, .price-item--regular, .price-item');
      var dtItem       = themePriceEl && themePriceEl.querySelector('.price-item--sale, .price-item--regular, .price-item');
      var pgSourceText = priceText || (dtItem && dtItem.textContent.trim());
      if (pgSourceText) {
        if (pgItem) {
          if (pgItem.textContent.trim() !== pgSourceText) pgItem.textContent = pgSourceText;
        } else if (themePriceEl) {
          preGalleryEl.innerHTML = themePriceEl.innerHTML;
          pgItem = preGalleryEl.querySelector('.price-item--sale, .price-item--regular, .price-item');
          if (pgItem) pgItem.textContent = pgSourceText;
        }
      }
    }

    // ─── 8. Hide payment installments on subscription ─────────────────────
    // Apply via both a section-level class AND an inline !important style on
    // the badges element — see applySubscriptionUI() for the rationale.
    applySubscriptionUI(isSubscription);

    // ─── 9. Refresh the SAVE X% yellow badge on the subscription card ─────
    updateSavingsBadge();
  }

  syncAllPrices();

  var syncTimer = null;
  function debouncedSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncAllPrices, 80);
  }

  var observerOpts = {
    childList: true, subtree: true,
    characterData: true,
    attributes: true, attributeFilter: ['class', 'value']
  };
  var observer = new MutationObserver(debouncedSync);
  observer.observe(section, observerOpts);

  (function() {
    var themePriceNode = section.querySelector(themePriceId);
    var preGalleryNode = section.querySelector('.product__pre-gallery-price');
    if (!themePriceNode || !preGalleryNode) return;

    function mirrorPrice() {
      var pgItem = preGalleryNode.querySelector('.price-item--sale, .price-item--regular, .price-item');
      var sealMoneyEl = themePriceNode.querySelector('.money.seal-money') ||
                        themePriceNode.querySelector('.money.ht-money')   ||
                        themePriceNode.querySelector('.money');
      if (sealMoneyEl && pgItem) {
        var sealText = sealMoneyEl.textContent.trim();
        if (sealText && pgItem.textContent.trim() !== sealText) pgItem.textContent = sealText;
        return;
      }
      var dtItem = themePriceNode.querySelector('.price-item--sale, .price-item--regular, .price-item');
      if (dtItem && pgItem) {
        var dtText = dtItem.textContent.trim();
        if (dtText && pgItem.textContent.trim() !== dtText) pgItem.textContent = dtText;
      } else if (dtItem && !pgItem) {
        preGalleryNode.innerHTML = themePriceNode.innerHTML;
      }
    }

    setTimeout(mirrorPrice, 100);
    var mirrorTimer = null;
    var priceObserver = new MutationObserver(function() {
      clearTimeout(mirrorTimer);
      mirrorTimer = setTimeout(mirrorPrice, 30);
    });
    priceObserver.observe(themePriceNode, { childList: true, subtree: true, characterData: true });
  })();

  function onPillAction(e) {
    if (e.target.closest && e.target.closest('.sls-option-container, .sls-option')) {
      setTimeout(syncAllPrices, 20);
      setTimeout(syncAllPrices, 150);
      setTimeout(syncAllPrices, 400);
      setTimeout(syncAllPrices, 800);
      setTimeout(syncAllPrices, 1500);
    }
  }
  section.addEventListener('click',    onPillAction);
  section.addEventListener('touchend', onPillAction);

  section.addEventListener('change', function(e) {
    if (e.target && (
      e.target.name === 'selling_plan' ||
      e.target.name === 'subs_interval' ||
      e.target.classList.contains('sls-option') ||
      e.target.classList.contains('sls-select')
    )) {
      setTimeout(syncAllPrices, 50);
      setTimeout(syncAllPrices, 250);
      setTimeout(syncAllPrices, 600);
    }
  });

  // ── Variant change: re-sync ATC price immediately + delayed catch-ups ────
  // Theme's variant-radios JS replaces the entire .btn__text on variant
  // change, wiping our [data-atc-price] span. syncAllPrices → ensureAtcStructure
  // rebuilds it. We also fire from option-radio change events because the
  // hidden [name="id"] input is updated programmatically (which never fires
  // a 'change' event in some theme implementations).
  function onVariantChanged() {
    var idInput = section.querySelector('[name="id"]');
    var newVariantId = idInput ? String(idInput.value) : null;
    if (newVariantId && variantOtpPriceMap[newVariantId] !== undefined) {
      try {
        var formatted = Shopify.formatMoney(variantOtpPriceMap[newVariantId], moneyFormat);
        // Rebuild structure first so [data-atc-price] is guaranteed to exist.
        ensureAtcStructure();
        section.querySelectorAll('[data-atc-price]').forEach(function(el) {
          // Don't touch a price span inside a "no-price" CTA (extra safety
          // in case one is ever rendered there).
          if (el.closest && el.closest('.button--no-price')) return;
          if (el.textContent.trim() !== formatted) el.textContent = formatted;
        });
      } catch (err) {}
    }
    syncAllPrices();
    setTimeout(syncAllPrices, 60);
    setTimeout(syncAllPrices, 200);
    setTimeout(syncAllPrices, 500);
  }
  section.addEventListener('change', function(e) {
    if (!e.target) return;
    // Trigger on the hidden id input OR on any radio inside the variant picker
    // (radio name is the option name — "Size", "Colour", etc. — not "id").
    if (e.target.name === 'id') {
      onVariantChanged();
      return;
    }
    if (e.target.type === 'radio' && e.target.closest && e.target.closest('.product-parameters')) {
      // Small delay so the theme's variant-radios JS has updated [name="id"]
      setTimeout(onVariantChanged, 20);
    }
  });
  // Variant button clicks (radios may not fire 'change' on label click in
  // every theme JS implementation) — re-sync as a safety net.
  section.addEventListener('click', function(e) {
    if (!e.target) return;
    // Click on a label inside the variant picker (label clicks don't always
    // fire change in every theme implementation).
    var inPicker = e.target.closest && e.target.closest('.product-parameters');
    if (!inPicker) return;
    if (e.target.closest('label[for], input[type="radio"]')) {
      setTimeout(onVariantChanged, 30);
      setTimeout(onVariantChanged, 200);
      setTimeout(onVariantChanged, 500);
    }
  });

  var slsEventNames = [
    'sls:change', 'sls:sellingPlanSelected', 'sls:planSelected',
    'SealSubscriptions:sellingPlanSelected', 'SealSubscriptions:change'
  ];
  slsEventNames.forEach(function(evtName) {
    document.addEventListener(evtName, function() {
      setTimeout(syncAllPrices, 30);
      setTimeout(syncAllPrices, 200);
    });
    window.addEventListener(evtName, function() {
      setTimeout(syncAllPrices, 30);
      setTimeout(syncAllPrices, 200);
    });
  });

  setInterval(syncAllPrices, 300);

  // ── Match variant/SealSubs corner radius to the ATC button's actual radius
  // Runs at DOM ready, after stylesheets finish loading, on resize (the
  // theme may swap radii at breakpoints), and after the SealSubs widget
  // hydrates (which can take a beat).
  matchAtcRadius();
  setTimeout(matchAtcRadius, 200);
  setTimeout(matchAtcRadius, 800);
  setTimeout(matchAtcRadius, 2000);
  window.addEventListener('load',   matchAtcRadius);
  window.addEventListener('resize', matchAtcRadius);

  // ── Desktop: move the product description (tagline) below the price ──────
  // On desktop, the "tagline" line of copy that's normally rendered above the
  // price block looks better when sitting BETWEEN the price and the variant
  // picker. We move it via JS so the merchant's block ordering in the
  // Customizer stays untouched.
  function reorderDescriptionDesktop() {
    if (window.innerWidth < 750) return;
    var infoContainer = section.querySelector('.product__info-container');
    if (!infoContainer) return;
    // Description block in the info container (not the pre-gallery summary)
    var desc = infoContainer.querySelector(':scope > .product__description');
    var priceWrap = infoContainer.querySelector(':scope > .price-wrapper, :scope > #' + (cfg.sectionId ? 'price-' + cfg.sectionId : ''));
    if (!desc || !priceWrap) return;
    // Already positioned right after the price? Skip.
    if (priceWrap.nextElementSibling === desc) return;
    priceWrap.insertAdjacentElement('afterend', desc);
  }
  reorderDescriptionDesktop();
  setTimeout(reorderDescriptionDesktop, 200);
  window.addEventListener('resize', reorderDescriptionDesktop);
  window.addEventListener('load',   reorderDescriptionDesktop);

  // ── Mobile gallery pill bullet styles ────────────────────────────────────
  (function() {
    if (window.innerWidth > 749) return;
    var bulletStyleId = 'sk-bullet-overrides-' + (cfg.sectionId || 'main');
    if (!document.getElementById(bulletStyleId)) {
      var s = document.createElement('style');
      s.id = bulletStyleId;
      var sectionSel = '#' + (cfg.sectionElementId || section.id);
      s.textContent =
        sectionSel + ' .product__pagination .swiper-pagination-bullet{' +
        'flex:1!important;display:block!important;' +
        'height:1.5px!important;max-height:1.5px!important;min-height:0!important;' +
        'border-radius:0!important;margin:0!important;padding:0!important;' +
        'opacity:1!important;box-shadow:none!important;' +
        'background:rgba(var(--color-foreground),.35)!important;' +
        'transition:background-color .3s ease!important;}' +
        sectionSel + ' .product__pagination .swiper-pagination-bullet-active{' +
        'background:rgb(var(--color-foreground))!important;}';
      document.head.appendChild(s);
    }
  })();

  // ── Markdown hyperlink + bold/italic parser ───────────────────────────────
  function parseMarkdownLinks(text) {
    return text
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/(?<!\*)\*(?!\*)([^*]+)(?<!\*)\*(?!\*)/g, '<em>$1</em>')
      // {i} (or {I}) → small inline info-icon badge (currentColor so it
      // inherits the surrounding text colour). Paste in the text setting.
      .replace(/\{i\}/gi, '<span class="sk-info-icon" aria-hidden="true"></span>')
      .replace(
        /\[([^\]]+)\]\(((?:https?:|mailto:|tel:)[^)]+)\)/g,
        function(_, label, url) {
          return '<a href="' + url.replace(/"/g, '&quot;') + '" class="product__text-icon-link" target="_blank" rel="noopener">' + label + '</a>';
        }
      );
  }

  function parseIconTextLinks() {
    section.querySelectorAll('[data-points-text]').forEach(function(el) {
      // Skip elements inside [data-dynamic-points] blocks --
      // updateDynamicPoints handles those (does {points} sub + markdown parsing).
      if (el.closest('[data-dynamic-points]')) return;
      var template = el.getAttribute('data-points-template') || el.textContent.trim();
      if (!template) return;
      // Run the parser when EITHER a markdown link OR a {i} info-icon
      // placeholder is present in the text. (Bold/italic markdown is also
      // handled by the parser so we trigger on those too.)
      var hasLink = /\[[^\]]+\]\((?:https?:|mailto:|tel:)[^)]+\)/.test(template);
      var hasInfoIcon = /\{i\}/i.test(template);
      var hasBoldItalic = /\*\*[^*]+\*\*|\*[^*]+\*/.test(template);
      if (!hasLink && !hasInfoIcon && !hasBoldItalic) return;
      if (!el.getAttribute('data-points-template')) {
        el.setAttribute('data-points-template', template);
      }
      var html = parseMarkdownLinks(template);
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  // ── Dynamic loyalty points ────────────────────────────────────────────────
  // In the Customizer, set the text_with_icon block text to:
  //   "EARN {points} POINTS WHEN YOU BUY THIS PRODUCT | DISCOVER REWARDS"
  // and check "Show dynamic loyalty points". {points} = 1 pt per £1 of price.
  // Updates automatically on variant change and OTP ↔ subscription switch.
  function updateDynamicPoints(priceInPence) {
    var pts = Math.round(priceInPence / 100);
    // Resolve the ATC button's actual border-radius so the points pill
    // matches the ATC's rounding rather than being a hard-coded value.
    var atcRadius = '';
    var atcEl = section.querySelector('.product-form__submit');
    if (atcEl) {
      atcRadius = getComputedStyle(atcEl).borderRadius || '';
      // Clamp pill-like radii so points box doesn't become fully rounded
      if (/^[0-9.]+px$/.test(atcRadius)) {
        var n = parseFloat(atcRadius);
        if (n > 24) atcRadius = '14px';
      }
    }
    section.querySelectorAll('[data-dynamic-points]').forEach(function(block) {
      // Belt-and-braces: paint the blue background + radius inline so it
      // shows even if the bundled CSS hasn't deployed yet / is cached.
      // Padding-left/right are left to the stylesheet so the icon column
      // stays aligned with the other icon-with-text rows.
      block.style.setProperty('background', '#B9CFFF', 'important');
      if (atcRadius) {
        block.style.setProperty('border-radius', atcRadius, 'important');
      }
      block.style.setProperty('padding-top', '0.95rem', 'important');
      block.style.setProperty('padding-bottom', '0.95rem', 'important');
      block.style.setProperty('margin-top', '0.8rem', 'important');
      block.style.setProperty('margin-bottom', '0.4rem', 'important');

      var textEl = block.querySelector('[data-points-text]');
      if (!textEl) return;
      var template = textEl.getAttribute('data-points-template');
      if (!template) {
        template = textEl.textContent.trim();
        textEl.setAttribute('data-points-template', template);
      }
      var newHtml = parseMarkdownLinks(template.replace(/\{points\}/gi, String(pts)));
      if (textEl.innerHTML !== newHtml) textEl.innerHTML = newHtml;
    });
  }

  updateDynamicPoints(otpPrice);

  // Points use OTP (full) price only -- no adjustment for subscription plans.
  // On variant switch, look up the new variant's OTP price from the product JSON.
  section.addEventListener('change', function(e) {
    if (!e.target || e.target.name !== 'id') return;
    var pts = variantOtpPriceMap[String(e.target.value)];
    updateDynamicPoints(pts !== undefined ? pts : otpPrice);
  });

  // ── Desktop thumbnail carousel ────────────────────────────────────────────
  // When a product has 6+ images the thumbnail strip is clamped to 5 thumbs
  // (CSS) and becomes a vertical scroll area. These arrows scroll it one
  // thumbnail at a time and hide themselves at the top / bottom of the range.
  (function setupThumbnailCarousel() {
    var col = section.querySelector('.product__media-sublist-col--carousel');
    if (!col) return;
    var scroller = col.querySelector('.product__media-sublist-outer');
    var upBtn    = col.querySelector('.js-sublist-arrow-up');
    var downBtn  = col.querySelector('.js-sublist-arrow-down');
    if (!scroller || !upBtn || !downBtn) return;

    var STEP = 108; // 100px thumbnail + 8px gap

    function refresh() {
      var atTop    = scroller.scrollTop <= 1;
      var atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;
      upBtn.hidden   = atTop;
      downBtn.hidden = atBottom;
    }
    function nudge(direction) {
      scroller.scrollTop += direction * STEP;
      // Recompute arrow visibility once the smooth scroll has settled.
      window.setTimeout(refresh, 350);
    }
    upBtn.addEventListener('click',   function () { nudge(-1); });
    downBtn.addEventListener('click', function () { nudge(1); });
    scroller.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load',   refresh);
    window.setTimeout(refresh, 300);
    refresh();
  })();

    parseIconTextLinks();
  updateDynamicPoints(otpPrice);
  setTimeout(function() { parseIconTextLinks(); updateDynamicPoints(otpPrice); }, 400);

  // Shopify Customizer: re-run when section reloads after a settings change
  document.addEventListener('shopify:section:load', function() {
    parseIconTextLinks();
    updateDynamicPoints(otpPrice);
  });
}

// Run init — handle both "DOM still loading" and "DOM already parsed" cases.
// This is the critical fix: when the section JS file is loaded by Shopify
// AFTER the DOMContentLoaded event has fired (common on product pages), a
// plain `addEventListener('DOMContentLoaded', …)` never runs.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.__initSkinPharmacyPdp);
} else {
  // DOM is already interactive/complete — call now.
  window.__initSkinPharmacyPdp();
}

  } catch(e) { console.error(e); }
})();
})();
